// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"WaiverWire__wrapper--1r47t"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/WaiverWire/WaiverWire.css
// module id = KwIN
// module chunks = 29